










import {defineComponent, PropType} from "@vue/composition-api";

export default defineComponent({
  name: 'DefaultDetails',
  props: {
    details: {type: Array as PropType<String[]>, required: true},
  }
})
